// extracted by mini-css-extract-plugin
export default {"requester-column":"TicketsTable_requester-column__edh6i"};